import React, { useState } from "react";
import { useRouteMatch } from "react-router-dom";
import SuggestionInput from "shared/@forms/SuggestionInput";
import Link from "shared/Link";
import LoadingPage from "shared/LoadingPage";
import OrdersList from "../OrdersList/index";
import styles from "./index.module.css";
import NoSelection from "./NoSelection";
import { Orders } from "./useOrders";
import { useIBOSearch } from "./useIBOSearch";

export const RECENT_IBOS_KEY = "membership.recentibos";
export const RECENT_EVENTS_KEY = "membership.recentevents";
export const RECENT_EVENTS_IBOS_KEY = "membership.recenteventiboslegacy";

export default function () {
  const { params } = useRouteMatch();
  const { iboNumber } = params;

  return (
    <Orders.Provider initialState={iboNumber}>
      <LookupByIBO iboNumber={iboNumber} />
    </Orders.Provider>
  );
}

function LookupByIBO({ iboNumber }) {
  const { orders, refreshIBOInfo } = Orders.useContainer();
  const [searchTerm, setSearchTerm] = useState("");
  const [editTerm, setEditTerm] = useState("");
  const { searchResults, isLoading } = useIBOSearch(searchTerm);

  return (
    <div className={styles.container}>
      <SuggestionInput
        value={editTerm}
        autoFocus={true}
        minLength={3}
        debounceTime={500}
        fetchSuggestions={setSearchTerm}
        suggestions={searchResults}
        isLoading={isLoading}
        placeholder="Search IBOs"
        onChange={(e) => {
          setEditTerm(e.target.value);
        }}
      >
        {(item, closePanel) => {
          const [, label, rest] = item.display.match(/^(.+):(.*)$/);

          return (
            <div key={item.contactPK} className={styles.iboListItem}>
              <div>
                <span>{label}:</span>{" "}
                <Link
                  to={`/events/orders/legacy/ibo/${item.iboNumber}`}
                  onClick={() => {
                    closePanel();
                  }}
                >
                  <span>{rest}</span>
                </Link>
              </div>
              <Link
                to={`/events/orders/legacy/ibo/${item.iboNumber}`}
                onClick={() => {
                  closePanel();
                }}
              >
                <span>View</span>
              </Link>
            </div>
          );
        }}
      </SuggestionInput>

      <div className={styles.details}>
        <DetailsErrorBoundary>
          {iboNumber ? (
            orders ? (
              <OrdersList ordersList={orders} refreshIBOInfo={refreshIBOInfo} />
            ) : (
              <LoadingPage text="Loading IBO" />
            )
          ) : (
            <div className={styles.noSelection}>
              <NoSelection />
            </div>
          )}
        </DetailsErrorBoundary>
      </div>
    </div>
  );
}

class DetailsErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    console.log("caught in error boundary", { error, errorInfo });
  }

  render() {
    if (this.state.hasError) {
      return <h1>An error occurred when looking up this IBO's info.</h1>;
    }

    return this.props.children;
  }
}
